// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .titleStyle {
    text-align: left;
    font: normal normal 600 20px/22px;
    letter-spacing: 0px;
    color: #262626;
    opacity: 1;
    height: 30%;
    padding-top: 3%;
    padding-left: 3%;
    padding-bottom: 2%;
  }

  .expCondStyle {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #D9D9D9;
    margin-top: 2%;
    border-radius: 0px;
    width: 25%;
  }

  .instrStyle {
    margin-left: 2%;
    background: #FFFFFF 0% 0% no-repeat padding;
    margin-top: 2%;
    border: 1px solid #D9D9D9;
    border-radius: 2px;
    width: 25%;
  }

  .statisticsfilterStyle {
    margin-left: 2%;
    color: #1890FF;
    border: 1px solid #1890FF;
  }

  .showingStyle {
    padding-left: 1%;
    padding-top: 2%;
    white-space: nowrap;
  }

  .showingTextStyle {
    font-weight: 600;
    color: #595959;
  }

  .studyCntStyle {
    font: normal normal normal 14px/22px;
    color: #595959;
  }

  .dividerStyle {
    background: #E8E8E8 0% 0% no-repeat padding-box;
    opacity: 1;
  }

  .chartOutDiv {
    border: 1px solid #CCCCCC;
    padding-bottom:10%;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 50%;
  }

  .chartInnerDiv {
    font-weight: 600;
    color: #262626;
    padding-left: 2%;
    padding-top: 1%;
  }

  .barStyle {
    opacity: 1;
    margin-left: 2%;
    margin-top: 2%;
  }

  .numTextStyle {
    text-align: left;
    font-weight: 600;
    letter-spacing: 0px;
    color: #262626;
    padding-left: 1%;
  }

  .numDivStyle {
    border: 1px solid #CCCCCC;
    opacity: 1;
    margin-left: 2%;
    width: 100%;
  }

  .ageStyle {
    margin-bottom: 2%;
    padding-left: 1%;
    margin-top: 2%;
  }

  .ageTextStyle {
    text-align: left;
    font-weight: 600;
    letter-spacing: 0px;
    color: #262626;
  }

  .minStyle {
    background: #E6F7FF 0% 0% no-repeat padding-box;
    border: 1px solid #91D5FF;
    border-radius: 2px;
    color: #1890FF;
    white-space: nowrap;
    padding: 0.5% 1% 0.5% 1%;
    margin-bottom: 5%;
    margin-right: 1%;
  }

  .fileSizeDiv {
    border: 1px solid #CCCCCC;
    opacity: 1;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 50%;
  }

  .fileSizeTextDiv {
    text-align: left;
    font-weight: 600;
    letter-spacing: 0px;
    color: #262626;
    padding-left: 2%;
    white-space: nowrap;
  }

  .totalFileStyle {
    font: normal normal 600 28px/47px;
    padding-left: 2%;
    color: #1890FF;
  }

  .clinicalOutStyle {
    border: 1px solid #CCCCCC;
    width: 50%;
    margin-left: 2%;
    margin-bottom: 2%;
    padding-bottom: 5%;
    margin-top:2%;
  }

  .clinicalInnerStyle {
    font-weight: 600;
    padding-left: 1%;
    color: #262626;
  }

  .clinicalSelectStyle {
    width: 250px;
    border: 1px solid #CCCCCC;
    margin-top: 2%;
    margin-left: 2%;
  }

  .modStyle {
    font-weight: 600;
    color: #262626;
    padding-left: 2%;
    padding-top: 1%;
  }

  .cardOuterStyle {
    background: #F5F5F5 0% 0% no-repeat padding-box;
    opacity: 1;
    height: 100%;
    margin-left: 5%;
    padding-left: 3%;
    padding-right: 3%;
  }

  .cardStyleStatistics {
    width: 100%;
    border: 1px solid #1890FF;
    margin-bottom: 2%;
    padding-left: 0%;
    padding-right: 3%;
  }

  .cardHeadStyle {
    font-weight: 600;
    padding-left: 5%;
    color: #262626;
  }

  .cardSampleStyle {
    font-weight: 600;
    color: #1890FF
  }
`, "",{"version":3,"sources":["webpack://./src/styles/StatisticsStyle.css"],"names":[],"mappings":"EAAE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,+CAA+C;IAC/C,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,2CAA2C;IAC3C,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,+CAA+C;IAC/C,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,+CAA+C;IAC/C,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB;EACF","sourcesContent":["  .titleStyle {\n    text-align: left;\n    font: normal normal 600 20px/22px;\n    letter-spacing: 0px;\n    color: #262626;\n    opacity: 1;\n    height: 30%;\n    padding-top: 3%;\n    padding-left: 3%;\n    padding-bottom: 2%;\n  }\n\n  .expCondStyle {\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #D9D9D9;\n    margin-top: 2%;\n    border-radius: 0px;\n    width: 25%;\n  }\n\n  .instrStyle {\n    margin-left: 2%;\n    background: #FFFFFF 0% 0% no-repeat padding;\n    margin-top: 2%;\n    border: 1px solid #D9D9D9;\n    border-radius: 2px;\n    width: 25%;\n  }\n\n  .statisticsfilterStyle {\n    margin-left: 2%;\n    color: #1890FF;\n    border: 1px solid #1890FF;\n  }\n\n  .showingStyle {\n    padding-left: 1%;\n    padding-top: 2%;\n    white-space: nowrap;\n  }\n\n  .showingTextStyle {\n    font-weight: 600;\n    color: #595959;\n  }\n\n  .studyCntStyle {\n    font: normal normal normal 14px/22px;\n    color: #595959;\n  }\n\n  .dividerStyle {\n    background: #E8E8E8 0% 0% no-repeat padding-box;\n    opacity: 1;\n  }\n\n  .chartOutDiv {\n    border: 1px solid #CCCCCC;\n    padding-bottom:10%;\n    margin-left: 2%;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    width: 50%;\n  }\n\n  .chartInnerDiv {\n    font-weight: 600;\n    color: #262626;\n    padding-left: 2%;\n    padding-top: 1%;\n  }\n\n  .barStyle {\n    opacity: 1;\n    margin-left: 2%;\n    margin-top: 2%;\n  }\n\n  .numTextStyle {\n    text-align: left;\n    font-weight: 600;\n    letter-spacing: 0px;\n    color: #262626;\n    padding-left: 1%;\n  }\n\n  .numDivStyle {\n    border: 1px solid #CCCCCC;\n    opacity: 1;\n    margin-left: 2%;\n    width: 100%;\n  }\n\n  .ageStyle {\n    margin-bottom: 2%;\n    padding-left: 1%;\n    margin-top: 2%;\n  }\n\n  .ageTextStyle {\n    text-align: left;\n    font-weight: 600;\n    letter-spacing: 0px;\n    color: #262626;\n  }\n\n  .minStyle {\n    background: #E6F7FF 0% 0% no-repeat padding-box;\n    border: 1px solid #91D5FF;\n    border-radius: 2px;\n    color: #1890FF;\n    white-space: nowrap;\n    padding: 0.5% 1% 0.5% 1%;\n    margin-bottom: 5%;\n    margin-right: 1%;\n  }\n\n  .fileSizeDiv {\n    border: 1px solid #CCCCCC;\n    opacity: 1;\n    margin-left: 2%;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    width: 50%;\n  }\n\n  .fileSizeTextDiv {\n    text-align: left;\n    font-weight: 600;\n    letter-spacing: 0px;\n    color: #262626;\n    padding-left: 2%;\n    white-space: nowrap;\n  }\n\n  .totalFileStyle {\n    font: normal normal 600 28px/47px;\n    padding-left: 2%;\n    color: #1890FF;\n  }\n\n  .clinicalOutStyle {\n    border: 1px solid #CCCCCC;\n    width: 50%;\n    margin-left: 2%;\n    margin-bottom: 2%;\n    padding-bottom: 5%;\n    margin-top:2%;\n  }\n\n  .clinicalInnerStyle {\n    font-weight: 600;\n    padding-left: 1%;\n    color: #262626;\n  }\n\n  .clinicalSelectStyle {\n    width: 250px;\n    border: 1px solid #CCCCCC;\n    margin-top: 2%;\n    margin-left: 2%;\n  }\n\n  .modStyle {\n    font-weight: 600;\n    color: #262626;\n    padding-left: 2%;\n    padding-top: 1%;\n  }\n\n  .cardOuterStyle {\n    background: #F5F5F5 0% 0% no-repeat padding-box;\n    opacity: 1;\n    height: 100%;\n    margin-left: 5%;\n    padding-left: 3%;\n    padding-right: 3%;\n  }\n\n  .cardStyleStatistics {\n    width: 100%;\n    border: 1px solid #1890FF;\n    margin-bottom: 2%;\n    padding-left: 0%;\n    padding-right: 3%;\n  }\n\n  .cardHeadStyle {\n    font-weight: 600;\n    padding-left: 5%;\n    color: #262626;\n  }\n\n  .cardSampleStyle {\n    font-weight: 600;\n    color: #1890FF\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
